import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Users';
import Object from './components/User'; //Take off S

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import Access from "constants/Access";

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, userAccess}) => (
	<div>
		<Switch>
			{userAccess <= Access.Supervisor && <ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection />
			</ErrorBoundaryRoute>}

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`/dashboard`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);